var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":_vm.clickItem}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }